"use client";

import { ComponentProps } from "react";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { Button } from "ui/core/button";

import { InsiderStatsOpenState } from "../data/types";

type Props = ComponentProps<typeof Button> & {
  openState?: InsiderStatsOpenState;
};

export const ViewAllButton = ({ openState }: Props) => {
  const { t } = useLang();
  const { updateQuery } = useUpdateQuery();

  return (
    <Button
      variant="secondary"
      onClick={() =>
        updateQuery({
          name: "insider",
          value: openState === "less" ? "more" : "less",
        })
      }
      className="w-full"
    >
      {openState === "less"
        ? t.analysis.chip.insider.viewAll
        : t.analysis.chip.insider.viewLess}
    </Button>
  );
};
